import { TID } from "@/lib/testIds";

export default function Footer() {
  return (
    <footer
      data-testid={TID.footer.root}
      className="relative bg-cream text-ink py-16 md:py-24"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <p className="font-display tracking-[0.28em] uppercase text-charcoal">
              Mirabilis
            </p>
            <p className="mt-5 max-w-sm text-sm leading-relaxed">
              Kitchen and joinery designed and built for the way you actually
              live. Sydney · Melbourne · Perth · Noosa.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-[11px] tracking-[0.28em] uppercase text-charcoal">
              Studio
            </p>
            <ul className="mt-5 space-y-3 text-sm">
              <li>By appointment only</li>
              <li>14 Atelier Lane, Surry Hills NSW</li>
              <li>+61 2 8000 0000</li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="text-[11px] tracking-[0.28em] uppercase text-charcoal">
              Credentials
            </p>
            <ul className="mt-5 space-y-3 text-sm">
              <li>HIA Lic. 22019283 · CBUS Member</li>
              <li>25-Year Cabinetry Warranty</li>
              <li>Fully insured nationwide</li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-stone flex flex-wrap items-center justify-between gap-4 text-xs tracking-[0.18em] uppercase text-ink/70">
          <span>© {new Date().getFullYear()} Mirabilis Kitchen and Joinery</span>
          <span>Made in Australia</span>
        </div>
      </div>
    </footer>
  );
}
